import { render, staticRenderFns } from "./autoPartesFilters.vue?vue&type=template&id=6c22955f"
import script from "./autoPartesFilters.vue?vue&type=script&lang=js"
export * from "./autoPartesFilters.vue?vue&type=script&lang=js"
import style0 from "./autoPartesFilters.vue?vue&type=style&index=0&id=6c22955f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports